/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import { AppNavigatorService } from '@/AppNavigator';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { apiConfig } from '@pages/ProfilePage/config/api.config';
import { updateProfileConfig } from '../../config/updateProfile.config';
import { UPDATE_MY_PROFILE } from '@pages/ProfilePage/api/graphql';
import { config } from 'process';
import { vappContainer } from '@/application';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUpdateProfilePluginMethods extends IPluginMethodMap {
  getUpdateProfile(args?: any): Promise<any>;
}
export interface UpdateProfileProps {
  firstName: string;
  lastName: string;
  occupation: string;
  telephone: string;
  address: string;
  city: string;
  country: string;
  profileImage: any;
}

export class UpdateProfilePlugin implements IAgentPlugin {
  readonly methods: IUpdateProfilePluginMethods;

  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args?: UpdateProfileProps) {
    console.log('data in mutation', args);
    await new Promise((r) => setTimeout(r, 2000));
    //await this.findCapsules();
    return {
      data: updateProfileConfig,
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      //const token = null;
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      console.log('token', token);
      const client = gql.getClient();
      const res = await client
        .mutation(UPDATE_MY_PROFILE, {
          updateMyProfileInput2: {
            firstName: args?.firstName,
            lastName: args?.lastName,
            occupation: args?.occupation,
            primaryContactNo: args?.telephone,
            address: {
              addressLine1: args?.address,
              city: args?.city,
              country: args?.country,
            },
            image: args?.profileImage?.base64,
          },
        })
        .toPromise();
      log.log('result of capsules=', res?.data?.capsules);
    } catch (err: any) {
      log.error('error in capsules=', err?.message);
      throw err;
    }
  }

  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
